// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_ey-0";
export var fulfillmentPanelBody = "_ey-1";